import React, { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
// eslint-disable-next-line import/order
import { useSelector,useDispatch } from "react-redux";
import { Booking } from "@/types/*";
import { eventName } from "../../../../../constants/events/eventName";
import { PASSENGER_TYPE } from "../../../../../constants/variables";
import { BookingDataContext } from "../../../../../context/BookingDataContext";
import { CommonDataContext } from "../../../../../context/CommonDataContext";
import { extractResource } from "../../../../../helper/extractResource";
import { resetLocalStorage } from "../../../../../services/resetLocalStorage";
import { trackUserActivity } from "../../../../../services/trackUserActivity";
import { deepCopy } from "../../../../../utils/jsonUtils";
import Calender from "../../../../SearchWidgetPanel/Check-in/Calendar/Calendar";
import ResCallenders from "../../../../SearchWidgetPanel/Check-in/ResCallenders";
import { displayCheckinMessage } from "../../../../SearchWidgetPanel/Check-in/helperFunctions/displayCheckinMessage";
import { ButtonV2 } from "../../../atoms/ButtonV2/ButtonV2";
import { ModalV2 } from "../../../atoms/ModalV2/ModalV2";
import { findPrimaryContact } from "helper/contact";
import { setSelectedJourneys, setCurrentBookingInStateContext } from "@/store/slices/checkIn";
import { resetVoucherList } from "../../../../../store/slices/booking";

export interface CheckInPopupProps {
  isOpen: boolean;
  currentBookingInState: { data: { data: Booking } };
  resourceData: {};
  handleClose: () => void;
  checkInRequirement: any;
}

export function CheckInSelectFlightPopupV2({
  isOpen,
  currentBookingInState,
  resourceData,
  handleClose,
  checkInRequirement
}: CheckInPopupProps) { 
  const journeys = currentBookingInState?.data?.data?.journeys ? currentBookingInState?.data?.data?.journeys : [];
  const passengerSegments = currentBookingInState?.data?.data?.journeys;

  const router = useRouter();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [paxDetailsByAgeGroups, setPaxDetailsByAgeGroups] = useState<{}>({});
  const dispatch = useDispatch();
  const selectedJourneys = useSelector((state:any)=>state.persistedReducers.checkIn.selectedJourneys)
  const bookingInState = useSelector((state: any) => state.persistedReducers.booking);
  const { passenger, setPassenger } = useContext<any>(BookingDataContext);

  const { passengerTypes, setSelectedSpecialFare } = useContext<any>(CommonDataContext);
  const specialFares = passengerTypes?.filter(
    (item: { passengerTypeCode: string }) =>
      item?.passengerTypeCode !== PASSENGER_TYPE.ADULT &&
      item?.passengerTypeCode !== PASSENGER_TYPE.CHILD &&
      item?.passengerTypeCode !== PASSENGER_TYPE.SENIOR_CITIZEN
  );
  const tempPaxDetailsByAgeGroups: any = {};

  const handleCheckInSubmit = () => {
    resetLocalStorage("CHECKIN_START");
    dispatch(resetVoucherList());
    setIsLoading(true);
    if (selectedJourneys?.length === 1) {
      dispatch(setCurrentBookingInStateContext(currentBookingInState?.data));
      trackUserActivity({
        eventName: eventName.MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED,
        details: {
          currentBookingInState: currentBookingInState?.data?.data,
          bookingInState
        }
      });
      router.push("/check-in-summary");
    } else if (selectedJourneys?.length > 1) {
      dispatch(setCurrentBookingInStateContext(currentBookingInState?.data));
      trackUserActivity({
        eventName: eventName.MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED,
        details: {
          currentBookingInState: currentBookingInState?.data?.data,
          bookingInState
        }
      });
      router.push("/check-in-summary");
    } else {
      trackUserActivity({
        eventName: eventName.MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED_ERROR,
        details: {
          currentBookingInState: currentBookingInState?.data?.data,
          bookingInState,
          error: "checkInSubmitFailed"
        }
      });
      setIsLoading(false);
    }
  };

  let checkedInJourney = [];
  let notCheckedJourney = [];

  const formatPaxObjForTravelersDetail = (
    passengerObject: { info: any; name: { first: any; last: any } },
    isInfant = false
  ) => {
    let passengerDetails = passengerObject?.info;

    if (isInfant === true) {
      passengerDetails = passengerObject;
    }

    return {
      first: passengerObject?.name?.first,
      last: passengerObject?.name?.last,
      gender: passengerDetails?.gender,
      dateOfBirth: passengerDetails?.dateOfBirth
    };
  };

  const updateOassengerDetailsByAge = (passengerData: any, matchedPaxType: string) => {
    if (typeof tempPaxDetailsByAgeGroups[matchedPaxType] === "undefined") {
      tempPaxDetailsByAgeGroups[matchedPaxType] = [];
    }
    tempPaxDetailsByAgeGroups[matchedPaxType].push(
      formatPaxObjForTravelersDetail(passengerData, matchedPaxType === PASSENGER_TYPE.INFANT)
    );
  };

  const updatePassengersDetail = async () => {
    let selectedSpecialFareType: any;
    let passengersHaveSeniors = false;
    let checkForInfants = false;
    const passengerObjectCopy: any = deepCopy(passenger);

    currentBookingInState?.data?.data?.passengers?.forEach((passengerObj, index) => {
      if (index === 0 && passengerObjectCopy) {
        passengerObjectCopy.adult = 0;
        passengerObjectCopy.total = 0;
        passengerObjectCopy.child = 0;
        passengerObjectCopy.seniorcitizen = 0;
        passengerObjectCopy.infant = 0;
      }

      const passengerType = passengerObj?.value?.passengerTypeCode;
      const isSpecialFare = [
        PASSENGER_TYPE.ADULT,
        PASSENGER_TYPE.ARMED_FORCE,
        PASSENGER_TYPE.MEDICAL,
        PASSENGER_TYPE.STUDENT
      ].includes(passengerType);
      const isInfant =
        passengerObj?.value?.infant &&
        typeof passengerObj?.value?.infant === "object" &&
        Object.keys(passengerObj?.value?.infant).length > 0;

      if (
        isSpecialFare ||
        passengerType === PASSENGER_TYPE.SENIOR_CITIZEN ||
        passengerType === PASSENGER_TYPE.CHILD ||
        passengerType === PASSENGER_TYPE.MINOR
      ) {
        const matchedPaxType: any =
          (passengerType === PASSENGER_TYPE.SENIOR_CITIZEN && PASSENGER_TYPE.SENIOR_CITIZEN) ||
          (isSpecialFare ? PASSENGER_TYPE.ADULT : PASSENGER_TYPE.CHILD);
        updateOassengerDetailsByAge(passengerObj?.value, matchedPaxType);
        passengerObjectCopy[matchedPaxType] += 1;
        passengerObjectCopy.total += 1;
        checkForInfants = isSpecialFare || passengerType === PASSENGER_TYPE.SENIOR_CITIZEN;
        passengersHaveSeniors = passengersHaveSeniors || passengerType === PASSENGER_TYPE.SENIOR_CITIZEN;
        selectedSpecialFareType = passengersHaveSeniors ? null : passengerType;
      }

      if (checkForInfants && isInfant) {
        updateOassengerDetailsByAge(passengerObj?.value?.infant, PASSENGER_TYPE.INFANT);
        passengerObjectCopy.infant += 1;
        checkForInfants = false;
      }
    });

    setPassenger(passengerObjectCopy);

    if (selectedSpecialFareType) {
      const specialFareObject = await specialFares?.find(
        (specialFare: any) => specialFare?.passengerTypeCode === selectedSpecialFareType
      );
      if (specialFareObject && Object.keys(specialFareObject).length > 0) {
        setSelectedSpecialFare(specialFareObject);
      }
    }

    const contactDetails = findPrimaryContact(currentBookingInState?.data?.data?.contacts);
    tempPaxDetailsByAgeGroups.PRIMARY_CONTACT_DETAILS = [
      { mobile: contactDetails?.phoneNumbers?.[0]?.number, email: contactDetails?.emailAddress }
    ];

    if (Object.keys(paxDetailsByAgeGroups).length === 0) {
      setPaxDetailsByAgeGroups(tempPaxDetailsByAgeGroups);
    }
  };

  if (passengerSegments) {
    checkedInJourney = checkInRequirement.filter(
      (ele: {
        data: { checkinByJourneyRequirements: { restrictions: null } };
        journeyDetails: { segments: { passengerSegment: any[] }[] };
      }) =>
        ele.data.checkinByJourneyRequirements.restrictions != null ||
        ele.journeyDetails.segments[0].passengerSegment.filter((liftStatus: string) => liftStatus === "CheckedIn" || liftStatus === "Boarded")
          .length === ele.journeyDetails.segments[0].passengerSegment.length
    );
    notCheckedJourney = checkInRequirement?.filter(
      (ele: {
        data: { checkinByJourneyRequirements: { restrictions: null } };
        journeyDetails: { segments: { passengerSegment: any[] }[] };
      }) =>
        ele.journeyDetails.segments[0].passengerSegment.filter((liftStatus: string) => liftStatus === "CheckedIn" || liftStatus === "Boarded")
          .length !== ele.journeyDetails.segments[0].passengerSegment.length
    );
  }

  useEffect(() => {
    let isComponentMounted = true;
    if (isComponentMounted) {
      updatePassengersDetail();
    }
    dispatch(setSelectedJourneys([]));
    return () => {
      isComponentMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModalV2
      size="sm"
      isOpen={isOpen}
      onClose={handleClose}
      modalTitle={extractResource(resourceData, "myBookingPopupOptionsCheckIn")}
      scrollable={true}
    >
      <div className="sm:min-w-[483px]">
        <div className="bg-background-highlight-primary px-1"    id="checkInSelectFlightPopup">
          <div id="journeyHeading" className="font-semibold text-lg text-typography-primary p-4 pb-0">
            {displayCheckinMessage(journeys, resourceData)}
            {journeys && (
              <span id="journeyStations">
                &nbsp;{journeys?.[0]?.designator?.origin}-{journeys?.[0]?.designator.destination}
              </span>
            )}
          </div>
          <p id="pnrDetails" className="font-medium text-sm text-typography-primary p-4 pt-2">
            {extractResource(resourceData, "pnr")} &nbsp;
            {currentBookingInState?.data?.data?.recordLocator}
            <span id="paxDetails">
              &nbsp;•&nbsp;
              {currentBookingInState?.data?.data?.passengers?.length}
              &nbsp;
              {currentBookingInState?.data?.data?.passengers?.length === 1
                ? extractResource(resourceData, "passenger")
                : extractResource(resourceData, "passengers")}
            </span>
            <span className="ml-2">
              {currentBookingInState?.data?.data?.extraSeatPassengers?.length > 0 && (
                <>
                  + {currentBookingInState?.data?.data?.extraSeatPassengers?.length}{" "}
                  {currentBookingInState?.data?.data?.extraSeatPassengers.length === 1
                    ? extractResource(resourceData, "extraSeat")
                    : extractResource(resourceData, "extraSeats")}
                </>
              )}
            </span>
          </p>
        </div>
        <div className="px-5 pt-2 pb-4">
          <p id="upcomingFlightsTitle" className="py-2">{extractResource(resourceData, "yourUpcomingFlights")}</p>
          <Calender
            isChangeBooking={false}
            passengerSegments={passengerSegments}
            CheckInRequirement={checkInRequirement}
            journeys={notCheckedJourney}
            resourceData={resourceData}
          />
          <ResCallenders
            isChangeBooking={false}
            passengerSegments={passengerSegments}
            currentBookingInState={currentBookingInState}
            CheckInRequirement={checkInRequirement}
            journeys={checkedInJourney}
            resJourney={checkedInJourney}
            resourceData={resourceData}
          />
        <div className="items-center w-40 py-5 m-auto">
          <ButtonV2
            id="checkInPopUpButton"
            blok={{ variant: "primary", text: extractResource(resourceData, "checkIn"), isFullWidthOnMobile: false }}
            isLoading={isLoading}
            onClick={handleCheckInSubmit}
            isDisabled={!selectedJourneys.length}
            />
        </div>
        {currentBookingInState?.data?.data?.isGroupBooking && (
          <span
            dangerouslySetInnerHTML={{
              __html: extractResource(currentBookingInState?.data?.data?.isGroupBooking, "groupBookingImportantNote")
            }}
          />
        )}
        </div>
      </div>

      {checkInRequirement && checkInRequirement.length === 0 && (
        <div className="p-8 flex justify-center">
          {extractResource(
            resourceData,
            "onlineCheckInOpens48HoursPriorToDepartureAFacilitationFeeOf200IsApplicableForAirportCheckInWithAssistance"
          )}
        </div>
      )}
    </ModalV2>
  );
}
